import React from 'react'

import Image from '@/components/image/image'

import * as style from './talks-section.module.scss'

type TalksSectionProps = Queries.DatoCmsTalksSection

const TalksSection: React.FC<TalksSectionProps> = ({ title, talks }) => {
  if (!title && !talks) {
    return null
  }
  return (
    <section className={style.section}>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="h300 text-brand-primary py-0">{title}</h2>
          </div>
        </div>
        {talks && talks?.length > 0 && (
          <div className={`row ${style.listTalks}`}>
            <>
              {talks.map((talk, index) => (
                <div className={`col-12 col-md-6 `} key={`talk-item-${index}`}>
                  <div>
                    <div className={style.talkHeader}>
                      <Image
                        image={talk?.image}
                        alt={talk?.image?.alt ?? talk?.title}
                        className={style.logo}
                      />
                      <h3 className="h100 text-brand-secondary py-0">
                        {talk?.title}
                      </h3>
                    </div>
                    <p className="text-base-100 b200">{talk?.text}</p>
                  </div>
                </div>
              ))}
            </>
          </div>
        )}
      </div>
    </section>
  )
}

export default TalksSection
